import React from "react";
import { useCountry } from "../lib/countryContext";
import { CaretDown } from "@phosphor-icons/react";

export const CountrySelector = () => {
  const { countries, selected, setSelected } = useCountry();
  const current = countries.find((c) => c.code === selected);

  return (
    <div className="relative" data-testid="country-selector-wrapper">
      <label className="sr-only" htmlFor="country-select">Country</label>
      <div className="flex items-center gap-2 border border-black bg-white pl-3 pr-2 py-1.5 shadow-[2px_2px_0px_#0A0A0A]">
        <span className="text-lg leading-none">{current?.flag || "🇪🇺"}</span>
        <select
          id="country-select"
          data-testid="country-select"
          value={selected || ""}
          onChange={(e) => setSelected(e.target.value)}
          className="bg-transparent outline-none text-xs tracking-[0.15em] uppercase pr-4 appearance-none cursor-pointer"
          style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700, WebkitAppearance: "none" }}
        >
          {countries.map((c) => (
            <option key={c.code} value={c.code}>
              {c.flag}  {c.name}
            </option>
          ))}
        </select>
        <CaretDown size={12} weight="bold" />
      </div>
    </div>
  );
};
